import { Link } from "react-router-dom";
import "./Categories.css";

export const CIRCLE_CATS = [
  { label: "All Products", slug: "all",          image: "/all-products.png" },
  { label: "Salwar Suits", slug: "salwar-suits",  image: "/salwar-suite.png" },
  { label: "Fabric",       slug: "fabric",        image: "/fabric.png" },
  { label: "Occasion",     slug: "occasion",      image: "/occasion.png" },
  { label: "Design",       slug: "design",        image: "/design.png" },
  { label: "Regional",     slug: "regional",      image: "/regional.png" },
  { label: "Fit & Type",   slug: "fit-type",      image: "/fit_&_type.png" },
  { label: "Color",        slug: "color",         image: "/color.jpg" },
  { label: "Features",     slug: "features",      image: "/feature.png" },
  { label: "Sets",         slug: "sets",          image: "/set.png" },
];

export default function Categories() {
  return (
    <section className="categories-section">
      <div className="circle-cats-wrap">
        <div className="circle-cats">
          {CIRCLE_CATS.map(cat => (
            <Link to={`/shop?category=${cat.slug}`} key={cat.slug} className="circle-cat">
              <div className="circle-img">
                <img src={cat.image} alt={cat.label} loading="lazy" decoding="async" />
              </div>
              <span>{cat.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
